<div class="ion-text-center">
  <ion-icon name="search-outline" style="font-size: 4rem;" color="medium"></ion-icon>
  <ion-text color="medium">
    <h3>No se encontraron resultados</h3>
  </ion-text>
</div>